/**
 * Normalize a URL for comparison purposes.
 * Adds https:// if missing, removes trailing slashes, lowercases.
 * Returns the original string (trimmed, lowercased) if parsing fails.
 */
export function normalizeUrl(url: string): string {
  const trimmed = url.trim()
  if (!trimmed) return ''
  try {
    const u = new URL(trimmed.startsWith('http') ? trimmed : `https://${trimmed}`)
    return u.origin + u.pathname.replace(/\/+$/, '')
  } catch {
    return trimmed.toLowerCase()
  }
}
